import { useEffect, useState } from "react";
import { CircleMarker, Tooltip, useMap } from "react-leaflet";

export default function CurrentLocationDot() {
  const map = useMap();
  const [pos, setPos] = useState<[number, number] | null>(null);

  useEffect(() => {
    if (!("geolocation" in navigator)) return;
    const watch = navigator.geolocation.watchPosition(
      (p) => {
        const ll: [number, number] = [p.coords.latitude, p.coords.longitude];
        setPos(ll);
      },
      () => {},
      { enableHighAccuracy: true, maximumAge: 15000, timeout: 10000 }
    );
    return () => navigator.geolocation.clearWatch(watch);
  }, []);

  if (!pos) return null;
  return (
    <CircleMarker
      center={pos}
      radius={6}
      pathOptions={{
        color: "#0ea5e9",
        weight: 2,
        fillColor: "#0ea5e9",
        fillOpacity: 0.9,
      }}
      pane="markerPane"
    >
      <Tooltip direction="top" offset={[0, -6]} opacity={0.9}>
        You
      </Tooltip>
    </CircleMarker>
  );
}

